import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSearchParameter } from '../helpers/browser';
import { IRootState } from '../redux';

interface IUseUnreadMessageCounters {
    unreadPublicMessageCount: number;
    unreadPrivateMessageCount: number;
}

const URL_PARAMETER_KEY = 'unreadPrivateMessageCount';

export const useUnreadMessageCounters = (): IUseUnreadMessageCounters => {
    const unreadPublicCount = useSelector<IRootState, number>(
        (state) => state?.mailbox?.unreadCounter?.unreadCount || 0
    );

    const [unreadPublicMessageCount, setUnreadPublicMessageCount] = useState<number>(unreadPublicCount);

    const [unreadPrivateMessageCount] = useState<number>(getUnreadPrivateMessageCount());

    useEffect(() => {
        setUnreadPublicMessageCount(unreadPublicCount);
    }, [unreadPublicCount]);

    return { unreadPrivateMessageCount, unreadPublicMessageCount };
};

const getUnreadPrivateMessageCount = (): number => {
    const unreadPrivateMessageCountString = getSearchParameter(URL_PARAMETER_KEY);

    return unreadPrivateMessageCountString ? parseInt(unreadPrivateMessageCountString, 10) : 0;
};
